import { initializeApp } from 'firebase/app'
import { getMessaging } from 'firebase/messaging'

const config = {
  apiKey: "AIzaSyCgK_URCgq0idjABwwxGow4UtcukAoSrL4",
  authDomain: "projeto-bis-c6949.firebaseapp.com",
  projectId: "projeto-bis-c6949",
  storageBucket: "projeto-bis-c6949.appspot.com",
  messagingSenderId: "1036819226334",
  appId: "1:1036819226334:web:e38c0b99a3cc774354ac4f",
  measurementId: "G-LYDFB2KPD1"
}
const firebase = initializeApp(config)

export const messaging = getMessaging(firebase)
